import { render } from "./FormattingBar.vue?vue&type=template&id=63bb4aa5&scoped=true"
import script from "./FormattingBar.vue?vue&type=script&lang=js"
export * from "./FormattingBar.vue?vue&type=script&lang=js"

import "./FormattingBar.vue?vue&type=style&index=0&id=63bb4aa5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bb4aa5"]])

export default __exports__